import React from 'react';
import MainInfoTracLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/ReverseMailTracking/Details';

function ReverseMailDetails() {
  return (
    <MainInfoTracLayout>
      <Content />
    </MainInfoTracLayout>
  );
}

export default ReverseMailDetails;
